import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppTheme, ThemeService } from 'src/app/shared/services/theme.service';

export type ExperienceTheme = AppTheme;

/** Theme accessor for the "experience" feature (home/portfolio list, reports).
 *  It deliberately holds NO state of its own: it delegates to the global
 *  {@link ThemeService} so the experience-scoped `data-theme` and the global
 *  `body[data-theme]` always agree. Keeping a second BehaviorSubject here
 *  caused the two to drift — toggling the shell flipped <body> but left the
 *  `.experience-scope` tokens light, painting white cards on a dark canvas. */
@Injectable({ providedIn: 'root' })
export class ExperienceThemeService {
  constructor(private themeService: ThemeService) {}

  get current$(): Observable<ExperienceTheme> {
    return this.themeService.current$;
  }

  get current(): ExperienceTheme {
    return this.themeService.current;
  }

  set(theme: ExperienceTheme): void {
    this.themeService.set(theme);
  }

  toggle(): void {
    this.themeService.toggle();
  }
}
